<template>
    <div
        class="app-container clearfix"
        v-loading="openloading"
        element-loading-text="加载中"
        element-loading-background="rgba(0, 0, 0, 0.1)"
    >
        <el-row style="padding-bottom: 15px">
            <el-col :span="24">
                <h3 class="headtitle">业务单据维护</h3>
                <span>Business Document</span>
            </el-col>
        </el-row>
        <el-row :gutter="20">
            <el-col :span="24">
                <el-card>
                    <el-row :gutter="20">
                        <el-col :span="24">
                            <div class="menuSection">
                                <span class="font-14 right-20">品牌:</span>
                                <el-select
                                    v-model="orderModel.brandId"
                                    placeholder="选择品牌"
                                    size="mini"
                                    @change="brandChange"
                                    v-if="
                                        brandList != null &&
                                        brandList.length > 0
                                    "
                                >
                                    <el-option
                                        v-for="item in brandList"
                                        :key="item.brandId"
                                        :label="item.brandName"
                                        :value="item.brandId"
                                    ></el-option>
                                </el-select>

                                <el-button
                                    size="mini"
                                    type="primary"
                                    icon="el-icon-refresh"
                                    class="pull-right"
                                    @click="updateTable"
                                    >更新</el-button
                                >
                                <el-button
                                    size="mini"
                                    type="primary"
                                    icon="el-icon-plus"
                                    class="pull-right right-10"
                                    @click="addTable"
                                    v-if="isShowAdd"
                                    >同步单据</el-button
                                >
                            </div>
                        </el-col>
                    </el-row>

                    <el-table
                        :data="tableData"
                        size="mini"
                        style="width: 100%; margin-top: 10px"
                        border
                    >
                        <el-table-column
                            label="操作"
                            width="200"
                            v-if="
                                isGranted(
                                    'Pages.BussinessOrderManagers.Edit'
                                ) ||
                                isGranted(
                                    'Pages.BussinessOrderManagers.Detail'
                                ) ||
                                isGranted('Pages.BussinessOrderManagers.Delete')
                            "
                        >
                            <template slot-scope="scope">
                                <el-tooltip content="编辑" placement="top">
                                    <el-button
                                        type="primary"
                                        icon="el-icon-edit"
                                        circle
                                        @click="edit(scope.row.id, true)"
                                        v-if="
                                            isGranted(
                                                'Pages.BussinessOrderManagers.Edit'
                                            )
                                        "
                                        size="mini"
                                    ></el-button>
                                </el-tooltip>
                                <el-tooltip content="刪除" placement="top">
                                    <el-button
                                        type="danger"
                                        icon="el-icon-delete"
                                        circle
                                        @click="del(scope.row.id)"
                                        v-if="
                                            isGranted(
                                                'Pages.BussinessOrderManagers.Delete'
                                            )
                                        "
                                        size="mini"
                                    ></el-button>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="name"
                            label="单据名称"
                        ></el-table-column>
                        <el-table-column
                            prop="code"
                            label="单据编号"
                        ></el-table-column>
                        <el-table-column
                            prop="basicDataNames"
                            label="基础档案"
                        ></el-table-column>
                        <el-table-column
                            prop="auxiliarys"
                            label="核算项"
                        ></el-table-column>
                    </el-table>
                    <pagerBar
                        ref="refPagerBar"
                        :apiURL="orderListApiUrl"
                        :GetData="getTableData"
                        :queryParam="queryParam"
                        :errorFunc="closeOpenloading"
                    ></pagerBar>
                </el-card>
            </el-col>
        </el-row>
        <el-dialog
            v-el-drag-dialog
            :title="xtitle"
            :visible.sync="dialogVisible"
            width="38%"
            :before-close="handleClose"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
        >
            <el-form
                label-width="110px"
                :model="orderModel"
                :rules="rules"
                ref="refOrderForm"
            >
                <el-form-item label="单据名称" prop="name">
                    <el-input
                        type="text"
                        v-model="orderModel.name"
                        :disabled="isDisabled"
                    ></el-input>
                </el-form-item>
                <el-form-item label="单据编号" prop="code">
                    <el-input
                        type="text"
                        v-model="orderModel.code"
                        :disabled="isDisabled"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    v-for="(item, index) in auxiliaryNames"
                    :key="index"
                    label="核算项"
                >
                    <el-input
                        style="width: 50%; padding-right: 10px"
                        v-model="item.code"
                        :id="item.name"
                        :value="item.code"
                        :disabled="isDisabled"
                    ></el-input>
                    <el-button
                        type="primary"
                        size="mini"
                        style="display: inline-block"
                        @click="showDialog(item.code)"
                        class="right-15"
                        >配置基础档案</el-button
                    >
                </el-form-item>
                <!-- <el-form-item label="配置参数" style="position: relative">
          <el-input v-model="detailParams" v-if="isShowBasic"> </el-input>
        </el-form-item> -->
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="save" v-if="isShow"
                    >确 定</el-button
                >
            </span>
        </el-dialog>
        <el-dialog
            v-el-drag-dialog
            title="基础资料同步设置"
            :visible.sync="basicTongbu"
            center
            width="590px"
            :before-close="handleClose"
            class="tongbu"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
        >
            <div style="text-align: center">
                <el-transfer
                    style="text-align: left; display: inline-block"
                    v-model="orderModel.basicDataIds"
                    target-order="push"
                    filterable
                    :titles="['档案数据', '同步档案']"
                    :button-texts="['删除', '添加']"
                    :props="transferProps"
                    :data="basicDataList"
                    @change="handleChange"
                    @right-check-change="chooseRight"
                >
                    <el-button
                        class="transfer-footer ml10"
                        slot="right-footer"
                        size="mini"
                        @click="handleUp(index)"
                        >上移
                    </el-button>
                    <el-button
                        class="transfer-footer"
                        slot="right-footer"
                        size="mini"
                        @click="handleDown(index)"
                        >下移
                    </el-button>
                    <el-tooltip
                        slot-scope="{ option }"
                        :content="option.name"
                        placement="left"
                        v-if="option.name.length >= 11"
                    >
                        <span>{{ option.name }}</span>
                    </el-tooltip>

                    <span
                        slot-scope="{ option }"
                        v-else-if="option.name.length < 11"
                        >{{ option.name }}</span
                    >
                </el-transfer>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="basicTongbu = false" size="mini"
                    >关闭</el-button
                >
            </span>
        </el-dialog>
    </div>
</template>

<script>
import axios from 'axios'
import config from '@/common/config.js'
import pagerBar from '@/views/pager/pagerBar'
import AjaxHelper from '@/common/js/AjaxHelper'
export default {
    data() {
        return {
            detailParams: '',
            detailParamArrays: [],
            currentInputVal: '',
            auxiliaryNames: [],
            isShowAdd: false,
            isShowBasic: false,
            basicTongbu: false, // 基础资料同步弹窗
            isDisabled: true,
            isInit: false,
            xtitle: '新增业务单据',
            openloading: true,
            isShow: false,
            queryParam: {
                brandId: null
            },
            orderListApiUrl:
                config.BASE_Middle_API + 'BussinessOrderManagers/GetAll',
            orderApiUrl: config.BASE_Middle_API + 'BussinessOrderManagers',
            orderModel: {
                id: null,
                name: '',
                code: '',
                brandId: '',
                basicDatas: '',
                basicDataIds: [],
                index: '',
                detailParamArrays: []
            },
            brandList: [],
            transferProps: { key: 'id', label: 'name' },
            basicDataList: [],
            dialogVisible: false, // 弹窗显示
            tableData: [], //表格数据
            rules: {
                name: [
                    { required: true, message: '请输入名称', trigger: 'blur' }
                ],
                code: [
                    { required: true, message: '请输入编号', trigger: 'blur' }
                ],
                className: [
                    {
                        required: true,
                        message: '请输入程序类名',
                        trigger: 'blur'
                    }
                ]
            },
            // 右侧列表项排序
            sort: '',
            // 右侧列表被选中的项
            item: '',
            // 右侧列表被选中项的下标值
            index: '',
            currentId: ''
        }
    },
    components: {
        pagerBar
    },
    mounted() {
        this.initBrands()
    },
    methods: {
        updateTable() {
            const _this = this
            _this.openloading = true
            AjaxHelper.put(_this.orderApiUrl + '/UpdateBussinessOrders', {
                brandId: _this.orderModel.brandId
            })
                .then(function (response) {
                    if (response.success) {
                        _this.isShowAdd = false
                        _this.Refresh()

                        _this.brandChange(_this.orderModel.brandId)
                        _this.openloading = false
                    }
                })
                .catch(function (error) {
                    console.log(error)
                    _this.openloading = false
                })
        },

        chooseRight(value) {
            let self = this
            self.item = value
        },
        handleUp(item, index) {
            //   item为选中的项    index为对应的index

            let self = this
            item = self.item //选中值
            if (item.length == 1) {
                //  因为右侧的选项是可以多选，但这里的上下移动事件，我做的是单项上移，每次上移一个空间，所以判断，当我的选中值只有一个选项时，进行上移操作
                //选中值的下标   【这里我不知道如何直接获取选中值的下标，所以用find()方法，在右侧值的数组里chooseRole中找选中项                                     对应的下标】
                self.orderModel.basicDataIds.find((val, indexs, arr) => {
                    // find()方法 val-项，indexs-下标，arr数组
                    if (val == item[0]) {
                        //  chooseRole数组的项val等于我选中的项item
                        index = indexs // 数组项的下标就是我当前选中项的下标
                    }
                })
                if (index == 0) {
                    //当选择的项的下标为0，即第一个，则提醒没有上移的空间，选择其他项进行上移
                    self.$message('没有上移的空间了')
                    return
                } // 上移-改变的数组（项和下标同时改变）
                let changeItem = JSON.parse(
                    JSON.stringify(self.orderModel.basicDataIds[index - 1])
                )
                self.orderModel.basicDataIds.splice(index - 1, 1)
                self.orderModel.basicDataIds.splice(index, 0, changeItem)
            } else {
                self.$message.error('只能选择一条数据进行上下移动')
                return
            }
            self.handleChange()
        },
        handleDown(item, index) {
            let self = this
            item = self.item
            if (item.length == 1) {
                //选中值的下标
                self.orderModel.basicDataIds.find((val, indexs, arr) => {
                    if (val == item[0]) {
                        index = indexs
                    }
                })
                if (index == self.orderModel.basicDataIds.length - 1) {
                    // 这里是length-1,因为下标值从0开始
                    self.$message('没有下移的空间了')
                    return
                }
                let changeItem = JSON.parse(
                    JSON.stringify(self.orderModel.basicDataIds[index])
                )
                self.orderModel.basicDataIds.splice(index, 1)

                self.orderModel.basicDataIds.splice(index + 1, 0, changeItem)
            } else {
                self.$message.error('只能选择一条数据进行上下移动')
                return
            }
            self.handleChange()
        },
        isShowAddButton() {
            const _this = this
            _this.openloading = true
            AjaxHelper.post(_this.orderApiUrl + '/IsShowAddButton', {
                brandId: _this.queryParam.brandId
            })
                .then(function (response) {
                    if (response.success) {
                        _this.isShowAdd = response.result
                        _this.openloading = false
                    }
                })
                .catch(function (error) {
                    console.log(error)
                })
        },
        addTable() {
            const _this = this
            _this.openloading = true
            AjaxHelper.post(_this.orderApiUrl + '/SyncBussinessOrders', {
                brandId: _this.orderModel.brandId
            })
                .then(function (response) {
                    if (response.success) {
                        _this.isShowAdd = false
                        _this.Refresh()

                        _this.brandChange(_this.orderModel.brandId)
                        _this.openloading = false
                    }
                })
                .catch(function (error) {
                    console.log(error)
                    _this.openloading = false
                })
        },
        showDialog(code) {
            const _this = this
            _this.basicTongbu = true
            // if (code != _this.currentInputVal) {
            _this.orderModel.basicDataIds = []
            _this.orderModel.basicDataNames = ''
            // } else {
            if (
                _this.orderModel.detailParamArrays != null &&
                _this.orderModel.detailParamArrays.length > 0
            ) {
                var arrays = _this.orderModel.detailParamArrays.find(
                    (item) => item.fieldName == code
                )
                if (arrays != undefined && arrays != null) {
                    // _this.orderModel.basicDataIds = arrays.value.split(",");
                    _this.orderModel.basicDataIds = [
                        ...arrays.value.split(',').map((x) => {
                            return Number(x)
                        })
                    ]
                }
            }
            // }
            _this.currentInputVal = code
        },
        getBasicData() {
            const _this = this
            _this.openloading = true
            AjaxHelper.get(_this.orderApiUrl + '/GetListForSelect', {
                brandId: _this.orderModel.brandId
            })
                .then(function (response) {
                    if (response.success) {
                        _this.basicDataList = response.result
                        _this.openloading = false
                    }
                })
                .catch(function (error) {
                    console.log(error)
                })
        },
        handleChange(val, position, arrays) {
            const _this = this

            // if (_this.orderModel.basicDatas) {
            _this.isShowBasic = true
            let arrayIds = []
            let arrayNames = []
            let detailArrays = []
            _this.orderModel.basicDataIds.forEach((t) => {
                if (t > 0) {
                    var name = _this.basicDataList.find((x) => x.id == t).name
                    arrayNames.push(name)
                    arrayIds.push(t)
                }
            })
            _this.orderModel.basicDataNames = arrayNames.join(',')
            let detailParamValues = {}
            let detailParamKeys = {}

            ;(detailParamKeys.核算项 = _this.currentInputVal),
                (detailParamKeys.档案 = arrayNames.join(','))
            ;(detailParamValues.fieldName = _this.currentInputVal),
                (detailParamValues.value = arrayIds.join(','))

            var index = detailArrays.findIndex((item) => {
                if (item.核算项 == detailParamKeys.核算项) {
                    return true
                }
            })
            if (index >= 0) {
                detailArrays.splice(index, 1)
            }
            detailArrays.push(detailParamKeys)
            let parseStr = ''
            let strDetail = ''
            let details = ''
            parseStr = JSON.stringify(detailArrays)
            const paramsObj = JSON.parse(parseStr)
            paramsObj.forEach((x) => {
                strDetail += x.档案 + ','
            })
            const reg = /,$/gi
            var ids = '#' + _this.orderModel.name + this.currentInputVal
            details = strDetail.replace(reg, '')
            document.querySelector(ids).value =
                _this.currentInputVal + '  ' + details
            var index1 = _this.orderModel.detailParamArrays.findIndex(
                (item) => {
                    if (item.fieldName == detailParamValues.fieldName) {
                        return true
                    }
                }
            )
            if (index1 >= 0) {
                _this.orderModel.detailParamArrays.splice(index1, 1)
            }
            _this.orderModel.detailParamArrays.push(detailParamValues)
            _this.detailParams = JSON.stringify(
                _this.orderModel.detailParamArrays
            )
            // }
        },
        initBrands() {
            const _this = this
            AjaxHelper.get(_this.orderApiUrl + '/GetSCMOrZ5Brands')
                .then(function (response) {
                    if (response.success) {
                        _this.brandList = response.result
                        _this.orderModel.brandId = _this.brandList[0].brandId
                        _this.queryParam.brandId = _this.brandList[0].brandId
                        _this.getBasicData()
                        _this.isShowAddButton()
                    }
                })
                .catch(function (error) {
                    _this.openloading = false
                    console.log(error)
                })
        },
        brandChange(val) {
            this.queryParam.brandId = val
            this.isShowAddButton()
            this.getBasicData()
        },
        closeOpenloading() {
            this.openloading = false
        },
        getTableData(d) {
            this.tableData = d
            this.openloading = false
        },
        add() {
            //新增按钮单击
            this.initModel()
            this.xtitle = '新增业务单据'
            this.isShow = true
            this.dialogVisible = true
        },
        getAuxiliaryNames() {
            const _this = this
            AjaxHelper.get(
                _this.orderApiUrl + '/GetBussinessOrderManagerForEdit',
                {
                    Id: _this.orderModel.id
                }
            )
                .then(function (response) {
                    if (response.success) {
                        _this.orderModel = response.result.bussinessOrderManager
                        _this.auxiliaryNames = _this.orderModel.auxiliaryNames
                    }
                })
                .catch(function (error) {})
        },
        edit(id, isEdit) {
            //编辑 查看按钮单击
            const _this = this
            if (isEdit) {
                _this.xtitle = '编辑业务单据'
            } else {
                _this.xtitle = '查看业务单据'
            }
            _this.auxiliaryNames = []
            _this.dialogVisible = true
            _this.orderModel.id = id
            _this.isShow = isEdit
            AjaxHelper.get(
                _this.orderApiUrl + '/GetBussinessOrderManagerForEdit',
                {
                    Id: id
                }
            )
                .then(function (response) {
                    if (response.success) {
                        _this.orderModel =
                            response.result.bussinessOrderManager
                        _this.auxiliaryNames =
                            _this.orderModel.auxiliaryNames
                        if (_this.orderModel.basicDataIds.length > 0) {
                            _this.isShowBasic = true
                        } else {
                            _this.isShowBasic = false
                        }
                        // 修复：等 DOM 渲染完成后再操作 querySelector
                        _this.$nextTick(function () {
                            if (_this.orderModel.detailParams) {
                                _this.orderModel.detailParamArrays.forEach(
                                    (t) => {
                                        let strDetail = ''
                                        let values = JSON.parse(
                                            JSON.stringify(t.value)
                                        )
                                        let arrayIds = [
                                            ...values.split(',').map((x) => {
                                                return Number(x)
                                            })
                                        ]
                                        let nameArrays = []
                                        arrayIds.forEach((t) => {
                                            var name = _this.basicDataList.find(
                                                (x) => x.id == t
                                            )
                                            if (name) {
                                                nameArrays.push(name.name)
                                            }
                                        })
                                        strDetail = nameArrays.join(',')
                                        const reg = /,$/gi
                                        var ids =
                                            '#' +
                                            _this.orderModel.name +
                                            t.fieldName
                                        let details = strDetail.replace(reg, '')
                                        var el = document.querySelector(ids)
                                        if (el) {
                                            el.value =
                                                t.fieldName + '  ' + details
                                        }
                                    }
                                )
                                _this.detailParams =
                                    _this.orderModel.detailParams
                            } else {
                                _this.auxiliaryNames.forEach((t) => {
                                    var ids = '#' + t.code
                                    var el = document.querySelector(ids)
                                    if (el) {
                                        el.value = t.code
                                    }
                                })
                                _this.detailParams = ''
                            }
                        })
                    }
                })
                .catch(function (error) {})
        },
        save() {
            //表单数据提交
            const _this = this
            this.$refs['refOrderForm'].validate((valid) => {
                if (valid) {
                    var arrays = []
                    JSON.parse(_this.detailParams).forEach((t) => {
                        if (t.value.indexOf(',') != -1) {
                            t.value.split(',').forEach((s) => {
                                if (!arrays.includes(s)) {
                                    arrays.push(s)
                                }
                            })
                        } else {
                            if (!arrays.includes(t.value)) {
                                arrays.push(t.value)
                            }
                        }
                    })
                    const confirmData = {
                        id: _this.orderModel.id,
                        name: _this.orderModel.name,
                        code: _this.orderModel.code,
                        basicDatas: arrays.join(','),
                        brandId: _this.orderModel.brandId,
                        detailParams: _this.detailParams
                    }
                    AjaxHelper.post(
                        _this.orderApiUrl + '/CreateOrEdit',
                        confirmData
                    )
                        .then(function (response) {
                            if (response.success) {
                                _this.$message({
                                    type: 'success',
                                    message: '操作成功'
                                })
                                _this.dialogVisible = false
                                _this.Refresh()
                                _this.brandChange(_this.orderModel.brandId)
                            }
                        })
                        .catch(function (error) {})
                }
            })
        },

        del(id) {
            //删除按钮单击
            const _this = this
            this.$confirm('此操作将删除该单据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    AjaxHelper.delete(_this.orderApiUrl + '/Delete', { Id: id })
                        .then(function (response) {
                            if (response.success) {
                                _this.$message({
                                    type: 'success',
                                    message: '删除成功'
                                })

                                _this.Refresh()
                            } else {
                                _this.$message({
                                    type: 'error',
                                    message: response.error.message
                                })
                            }
                        })
                        .catch(function (error) {})
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    })
                })
        },
        handleClose(done) {
            done()
        },
        initModel() {
            //清除表单数据和验证
            if (this.$refs['refOrderForm']) {
                this.$refs['refOrderForm'].resetFields()
                this.orderModel = {
                    id: null,
                    name: '',
                    code: '',
                    index: '',
                    basicDatas: []
                }
            }
        },
        Refresh() {
            //刷新table数据
            this.isShow = false
            this.$refs.refPagerBar.Refresh()
        }
    }
}
</script>

<style scoped="scoped">
dt,
dd {
    margin: 0;
    padding: 0;
}
.el-card {
    height: calc(100vh - 217px) !important;
}
</style>
